import { allCountries } from 'country-region-data';
export var countryOptions = allCountries.map(function (country) { return ({ name: country[0], value: country[1] }); });
export var countriesByCode = allCountries.reduce(function (acc, country) {
    acc[country[1]] = country;
    return acc;
}, {});
export var countryRegionsByCode = allCountries.reduce(function (acc, country) {
    acc[country[1]] = country[2].map(function (region) { return ({ name: region[0], value: region[1] }); });
    return acc;
}, {});
export function getDefaultCountry() {
    try {
        var language = navigator.languages[0];
        var country = language.split('-')[1];
        if (countriesByCode[country])
            return country;
    }
    catch (_a) {
        //
    }
    return 'US';
}
export function isNumericPostalCode(country) {
    switch (country) {
        case 'US':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=countries.js.map